import createHttpClient from './httpClient'

const baseUrl = new URL('/api/v1/dispute/admin', process.env.VUE_APP_PUBLIC_SERVICE_BASE_URL).href

const httpClient = createHttpClient(baseUrl)

const DisputesApi = {
  /**
   * Adjust calls payment directly as a dispute
   * @param {import('../@types/disputes').AdjustCallsPaymentRequestForDispute} disputeDetails 
   * @returns {Promise}
   */
  async adjustCallsPaymentsForDispute(disputeDetails) {
    const url = ``

    return await httpClient.post(url, disputeDetails)
  },
}

export default DisputesApi
